import { Component, OnInit, Input } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';

import { ActivatedRoute, Router } from '@angular/router';
import { PessoaService } from '../../../../../../services/pessoas/pessoas.service';
import { PessoaDTO } from '../../../../../../models/clientes/pessoa.model';

@Component({
  selector: 'app-clientes-card',
  templateUrl: './clientes-card.component.html',
  styleUrls: ['./clientes-card.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class ClientesCardComponent implements OnInit {
  @Input() clienteID: number | undefined;
  pessoa: PessoaDTO = {} as PessoaDTO;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private pessoaService: PessoaService
  ) {}

  async ngOnInit() {
    if (this.clienteID === undefined) return;
    await this.findCliente(this.clienteID);
  }

  findCliente(clenteId: number): Promise<void> {
    return new Promise((resolve) => {
      this.pessoaService
        .getById('/pessoas', String(clenteId))
        .subscribe((response) => {
          this.pessoa = response;
          resolve();
        });
    });
  }
}
